/**
 * Bar click sulla timeline scadenze: navigazione verso lista vetture con filtro `between` sul mese cliccato (etichetta IT).
 */
export const buildContractsExpiringBarNavigateHandler = ({ navigate, baseFilters, field = '_related_contract_end_at' }) => {
    const monthNames = [
        'gennaio',
        'febbraio',
        'marzo',
        'aprile',
        'maggio',
        'giugno',
        'luglio',
        'agosto',
        'settembre',
        'ottobre',
        'novembre',
        'dicembre',
    ];

    return (params) => {
        const label = typeof params === 'string' ? params : params?.label ?? params;
        if (!label || typeof label !== 'string') return;

        const [monthStr, yearStr] = label.toLowerCase().split(' ');
        const month = monthNames.indexOf(monthStr);
        const year = parseInt(yearStr, 10);
        if (month < 0 || Number.isNaN(year)) return;

        const start = new Date(year, month, 1);
        const end = new Date(year, month + 1, 0);

        const yearStart = start.getFullYear();
        const monthStart = String(start.getMonth() + 1).padStart(2, '0');
        const dayStart = String(start.getDate()).padStart(2, '0');

        const yearEnd = end.getFullYear();
        const monthEnd = String(end.getMonth() + 1).padStart(2, '0');
        const dayEnd = String(end.getDate()).padStart(2, '0');

        const localfilters = {
            items: [
                ...(baseFilters?.items || []),
                {
                    field,
                    operator: 'between',
                    value: {
                        from: `${yearStart}-${monthStart}-${dayStart}T00:00:00.000Z`,
                        to: `${yearEnd}-${monthEnd}-${dayEnd}T23:58:59.000Z`,
                    },
                },
            ],
        };

        const qs = localfilters.items
            .map((f) => {
                const value =
                    typeof f.value === 'object'
                        ? encodeURIComponent(JSON.stringify(f.value))
                        : encodeURIComponent(f.value);
                return `${encodeURIComponent(f.field)}=${value}`;
            })
            .join('&');

        navigate(`/cars/car?${qs}`);
    };
};
